import script from "./HeaderInternationalamnesty.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderInternationalamnesty.vue?vue&type=script&setup=true&lang=js"

import "./HeaderInternationalamnesty.vue?vue&type=style&index=0&id=65053eb7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65053eb7"]])

export default __exports__